import React from "react";
import { Row, Col } from "react-bootstrap";
import { itemPrice, priceEUR, getIngredients } from "../../helper/functions";
import CartItemCount from "../Misc/CartItemCount";

export const CartItem = ({ item }) => {
  return (
    <div>
      <Row className="align-center">
        <Col>
          <h5 className="mt-2">{item.dough.name}</h5>
        </Col>
        <Col>
          <CartItemCount item={item} />
        </Col>
        <Col>
          <div className="float-end mt-2 me-2">{priceEUR(itemPrice(item))}</div>
        </Col>
      </Row>
      <div>{getIngredients(item.ingredients)}</div>
      <hr />
    </div>
  );
};
